import { apiFetch } from "../../api";

const BASE_URL = "/api/category-budget";

export async function getBudgets(month) {
  const res = await apiFetch(`${BASE_URL}?month=${month}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function saveBudget(payload) {
  return apiFetch(BASE_URL, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
